import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { RangeSetting } from 'icreate/common/models/editor-viewer-element';
import * as _ from 'lodash';

@Component({
    selector: 'app-range-color-indicator',
    templateUrl: './range-color-indicator.component.html',
    styleUrls: ['./range-color-indicator.component.css'],
    standalone: false,
})
export class RangeColorIndicatorComponent implements OnInit {
    @ViewChild('minInput') minInput: ElementRef;
    @ViewChild('maxInput') maxInput: ElementRef;

    @Input() color: string = 'rgb(255, 255, 255)';
    @Input() minRange: number;
    @Input() maxRange: number;
    @Input() enabled: boolean = true;
    @Input() min: number;
    @Input() max: number;
    @Input() foreignObject: SVGElement;
    @Input() colorId: string;
    @Output() onRangeChange: EventEmitter<RangeSetting> = new EventEmitter();
    @Output() onRangeDelete: EventEmitter<number> = new EventEmitter();

    rgb: string = '';

    ngOnInit(): void {
        this.colorChange();
    }

    colorChange(): void {
        const match = this.color?.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*([\d\.]+)?\)/);

        if (!match) {
            return;
        }

        const r = parseInt(match[1], 10);
        const g = parseInt(match[2], 10);
        const b = parseInt(match[3], 10);

        this.rgb = `${r}, ${g}, ${b}`;
    }

    updateEnabledRange() {
        this.enabled = !this.enabled;
        this.emitColorChange();
    }

    emitColorChange() {
        this.onRangeChange.emit({
            colorId: this.colorId,
            min: Number(this.min),
            max: Number(this.max),
            enabled: this.enabled,
        });
    }

    minChange(min) {
        if (min < this.minRange) {
            this.min = this.minRange;
            this.minInput.nativeElement.value = this.min;
        } else if (min > this.maxRange) {
            this.min = this.maxRange;
            this.minInput.nativeElement.value = this.min;
        }
    }

    maxChange(max) {
        if (max > this.maxRange) {
            this.max = this.maxRange;
            this.maxInput.nativeElement.value = this.max;
        } else if (max < this.minRange) {
            this.max = this.minRange;
            this.maxInput.nativeElement.value = this.max;
        }
    }

    colorStateDelete() {
        this.onRangeDelete.emit();
    }
}
